module.exports = __webpack_public_path__ + "img/search.e00eb144.png";